//import { Link, Redirect } from "wouter";
import { Link } from 'react-router-dom';

//import Header from "../Components/Header";

import { Container, Row, Col, Card } from "react-bootstrap";
import { useOktaAuth } from "@okta/okta-react";

const Home = () => {
  const { authState, oktaAuth } = useOktaAuth();

  return (
        <Container>
            <br></br>
        <Row>
            <Col sm={12} className="text-center">
            <h3>React / API Authentication Demo</h3>
            <br></br>
            <h5>
                Routing, content, and API acceess based on Okta authenticaiton.
            </h5>
            </Col>
        </Row>
        <br></br>
        <Row>
            <Col className="text-center add-border" style={{padding: "1em"}}>
                {!authState?.isAuthenticated && <Card style={{ margin: "0 auto" }}>
                    <Card.Header>You are Not Logged In</Card.Header>
                        <Card.Body>
                            Authenticated users see a different card.
                        </Card.Body>
                    </Card>
                }
            </Col>
            <Col className="text-center add-border" style={{padding: "1em"}}>
                {authState?.isAuthenticated && <Card style={{ margin: "0 auto" }}>
                    <Card.Header>You are Logged In</Card.Header>
                        <Card.Body>
                            This card only displays for authenticated users.
                        </Card.Body>
                    </Card>
                }
            </Col>
        </Row>
        <br/><br/>
        <Row>
            <Col className="text-center">
                <h3>Page Descriptions / Details</h3>
            </Col>
        </Row>
        <Row>
            <Col sm={3} className="text-center">
                <Card style={{ margin: "1em auto", height: "160px" }}>
                    <Card.Header>Home</Card.Header>
                    <Card.Body>
                        Open to all users. Content different based on authenticaiton.
                    </Card.Body>
                </Card>
            </Col>
            <Col sm={3} className="text-center">
                <Card style={{ margin: "1em auto", height: "160px" }}>
                    <Card.Header><Link to="/TestAPI">Test API Authentication</Link></Card.Header>
                    <Card.Body>
                        Open to all users. API access based on authenticaiton.
                    </Card.Body>
                </Card>
            </Col>
            <Col sm={3} className="text-center">
                <Card style={{ margin: "1em auto", height: "160px" }}>
                    <Card.Header><a href='/swagger/index.html'>Swagger UI</a></Card.Header>
                    <Card.Body>
                        Not part of authentication test. UI for testing API.
                    </Card.Body>
                </Card>
            </Col>
            <Col sm={3} className="text-center">
                <Card style={{ margin: "1em auto", height: "160px" }}>
                    <Card.Header><Link to="/instructions">Instruction</Link></Card.Header>
                    <Card.Body>
                        Abbreviated instructions for using code in this demo. Requires authenticaiton. Unauthenticated users will get a 401.
                    </Card.Body>
                </Card>
            </Col>
            <Col sm={3} className="text-center">
                <Card style={{ margin: "1em auto", height: "160px" }}>
                    <Card.Header>{authState?.isAuthenticated ? <Link to="/Profile">Profile</Link>: "Profile"}</Card.Header>
                    <Card.Body>
                        Provides details on information available about user. Page requires/forces authentication. Link not visible if not authenticated.
                    </Card.Body>
                </Card>
            </Col>
            <Col sm={3} className="text-center">
                <Card style={{ margin: "1em auto", height: "160px" }}>
                    <Card.Header>Login/Logout Button</Card.Header>
                    <Card.Body>
                        Part of Header component.
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    </Container>
  );
};

export default Home;